import type { LibField, LibForm } from '../components/FormModal.js';

/**
 * credifyfbs#241 - a filled form shows as it was filled. Each fill keeps the questions it was
 * filled on (their order and options, plus the form's description); View, Edit and PDF draw the
 * fill from those, so questions added to or removed from the form in the Form Builder since
 * never change it. A fill saved before that kept nothing shows today's form, as before.
 */
export interface FilledLayout {
  fields: LibField[];
  description?: string;
}

/** What a new fill keeps of the form it is filled on (nothing for a form with no questions). */
export function layoutOf(form: LibForm): FilledLayout | undefined {
  const fields = form.fields ?? [];
  if (!fields.length) return undefined;
  return {
    fields: fields.map((f) => ({ ...f, required: !!f.required, options: f.options ?? [] })),
    description: form.description ?? '',
  };
}

/** The form to draw a saved fill on: its kept questions, or today's form for an older fill. */
export function formAsFilled(
  today: LibForm | undefined,
  fill: { formId: string; formName: string; layout?: FilledLayout | null },
): LibForm {
  const form: LibForm = today ?? {
    id: fill.formId,
    name: fill.formName,
    description: '',
    source: 'custom',
    fields: [],
  };
  const kept = fill.layout?.fields;
  if (!kept?.length) return form;
  return {
    ...form,
    description: fill.layout?.description ?? form.description,
    fields: kept.map((f) => ({ ...f, options: f.options ?? [] })),
  };
}
